import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileNav } from './MobileNav';
import { InstallPrompt } from './InstallPrompt';
import { SkipToContent } from '@/components/ui/SkipToContent';

interface MainLayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

export function MainLayout({ children, hideFooter }: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <SkipToContent />
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 pb-14 sm:pb-0 outline-none">
        {children}
      </main>
      {!hideFooter ? <Footer /> : null}
      <MobileNav />
      <InstallPrompt />
    </div>
  );
}
